import { PropsWithChildren } from 'react';
import { useGetWorklistRecord } from 'hooks/api/worklist/useGetWorklistRecord';
import { Indicator as IndicatorBadge } from '@mantine/core';
import { DocumentIdProps } from 'models/general';

export const WorklistIndicator = ({ documentId, children }: DocumentIdProps & PropsWithChildren) => {
  const { data: document } = useGetWorklistRecord({ documentId });

  return (
    <IndicatorBadge
      offset={2}
      label={document?.notes?.length || 0}
      size={20}
      color={'var(--mantine-color-turquoise-5)'}
      withBorder
    >
      {children}
    </IndicatorBadge>
  );
};
